import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';

export const toggleShowScheduleInWorkload = createAsyncThunk<void, void, { state: IState }>(
  'uiView/toggleShowScheduleInWorkload',
  (_, { dispatch }) => {
    dispatch(persistUserPreferences());
  }
);
